export default {
  header: {
    accounts: 'Cuentas',
    rewards: 'Recompensas',
    mundial: 'Mundial',
    whoweare: 'Quiénes somos',
    contact: 'Contacto',
    register: 'Registro',
    log_in: 'Iniciar sesión'
  },

  slider: {
    conocer_mas: 'Conocer más',
    participar: 'Participar',
    slider1text: 'Abrí tu cuenta en Estados Unidos desde cualquier parte del mundo.',
    slider2text: 'Ahorrá en dólares y asegurá tu dinero.',
    slider3text: 'Nuestro programa de beneficios te permite viajar en nuestra flota de aviones privados.',
    slider4text: 'Volá desde Argentina a cualquier parte del mundo.',
    slider5text: 'Viajá al mundial con los campeones del 86\' en el Tango D10S.'
  },
  home_page: {
    div_title_h1: 'Somos la fintech de la próxima generación',
    slider1text: 'Abrí tu cuenta en Estados Unidos desde cualquier parte del mundo.',
    top_l_h2t: 'Pagá y recibí pagos fácilmente.',
    top_l_p1t: 'Desde cualquier parte del mundo',
    top_l_h2b: 'Depósitos con cobertura del FDIC',
    top_l_p2b: 'Asociado a una variedad de bancos e instituciones asegurados por el Gobierno Federal de Estados Unidos para ofrecer productos y servicios bancarios*.',
    top_l2_h2t: 'Multi-monedas',
    top_l2_p1t: 'Nuestras cuentas le permiten administrar múltiples monedas extranjeras.',
    top_l2_h2b: 'Criptomonedas',
    top_l2_p1b: 'Utilizá nuestra wallet para hacer custodia y trading de criptomonedas.',
    calculator_sec_h1: 'Usá nuestra calculadora para volar desde Argentina a cualquier parte del mundo',
    calculator_sec_p: 'Nuestro programa de beneficios te permite volar en nuestra flota de aviones a precios increíbles.',
    cards_card1_h3: 'Aviones disponibles',
    cards_card1_p: 'todo el año',
    cards_card2_h3: 'Vuelos programados',
    cards_card2_p: 'en 48 hs',
    cards_card3_h3: 'Viajá solo, en familia',
    cards_card3_p: 'o con amigos',
    cards_card4_h3: 'Tarifas especiales',
    cards_card4_p: 'para volar desde Argentina',
    contact_form_home_h1: 'Contactanos',
    contact_form_h_label1: 'Nombre y Apellido',
    contact_form_h_label2: 'Email',
    contact_form_h_label3: 'Mensaje',
    contact_form_btn1: 'Enviando',
    contact_form_btn2: 'Enviar',
    footer_link1: 'Cuentas',
    footer_link2: 'Recompensas',
    footer_link3: 'Quiénes somos',
    footer_link4: 'Contacto',
    footer_link5: 'Soporte',
    footer_link6: 'Preguntas frecuentes',
    footer_disclaimer: '* Give and Get es una marca comercial de Finanleads LLC. Finanleads LLC es una fintech y no un banco. Finanleads se asocia con una variedad de bancos e instituciones asegurados por la FDIC para ofrecer productos y servicios bancarios.',
    copy_r: 'Todos los derechos reservados'
  },
  accounts_page: {
    accounts_header_text1: 'PERSONAS',
    accounts_header_text2: 'EMPRESAS',
    midd_section_h1: 'Cuentas basadas en EE. UU. Una plataforma simple y segura.',
    midd_section_p: 'Nuestra plataforma está diseñada para mantener el control de sus finanzas y  administrar tu dinero desde cualquier parte del mundo',
    info_s_card1: 'Transacciones simples: ¡sólo unos pocos clics!',
    info_s_card2: 'Pague y reciba pagos fácilmente',
    info_s_card3: 'Transferencias electrónicas nacionales e internacionales',
    info_s_card4: 'Envíe y reciba pagos ACH',
    info_s_card5: 'Enviar, recibir y almacenar activos digitales',
    info_s_card6: 'Depósito y emisión de cheques'
  },
  rewards_page: {
    rewards_page_h1: 'Nuestro programa de beneficios brinda recompensas y beneficios en nuestra flota de aviones privados.',
    rewards_page_p: 'Volá desde Argentina con tu familia,amigos o invitados a cualquier parte del mundo.',
    avions_sec_h1: 'Cumplí el sueño de viajar al mundial con los campeones del 86\' en el Tango D10S.',
    bigavion_sec_h1: 'Usá la calculadora y volá en nuestra amplia flota de aviones privados.',
    bigavion_sec_p: 'Nuestra calculadora te permite viajar a precios bonificados o totalmente gratis'
  },
  world_cup_page: {
    mundial_cont_h1: 'Cumplí el sueño de viajar al mundial de la mano de D10S',
    mundial_cont_h2: 'Con los campeones del 86',
    mundial_cont_p: 'Participa por 1 pasaje con entradas de la Selección Nacional y estadía completa. iHay 5 ganadores! Solo tenes que cumplir con estos requisitos para participar del sorteo:',
    mundial_cont_h4: 'REQUISITOS',
    mundial_cont_li1: 'Abri una cuenta de PERSONA o EMPRESA en giveandget.io',
    mundial_cont_li2: 'Si abris una cuenta de PERSONA, tenes que depositar al menos USD 2,500 durante el primer mes ',
    mundial_cont_li3: 'Si abris una cuenta de EMPRESA, tenes que hacer un depósito inicial de al menos USD 50,000',
    mundial_cont_lip: 'iY listo! Ya estas participando',
    mundial_cont_btn: 'Participar',
    mundial_cont_a: 'Ver bases y condiciones'
  },
  contact_page: {
    contact_page_p: 'Para dudas, consultas y soporte escribir a',
    contact_c_form_h1: 'Contactanos',
    support_header: 'Soporte'
  },
  who_we_are_page: {
    who_page_h1: 'Somos una fintech que cree en la economía circular.',
    who_page_p: 'Estamos enfocados en brindar servicios financieros internacionales a nuestros clientes con una amplia gama de soluciones que permiten de una manera flexible, sencilla y sin inconvenientes, controlar las finanzas personales y comerciales.',
    who_card1: 'Inclusión Financiera',
    who_card1_p: 'Creemos firmemente que la inclusión financiera debe funcionar junto con la inclusión social.',
    who_card2: 'Conciencia Empresarial',
    who_card2_p: 'Creemos que si hay conciencia empresarial, hay menos dependencia del estado.',
    who_card3: 'Sueños',
    who_card3_p: 'Creemos que todos deben soñar y queremos ayudar a cumplir esos sueños.',
    who_card4: 'Recompensas',
    who_card4_p: 'Creemos que las personas que hacen el bien deben ser recompensadas de igual manera',
    box_big_h2: 'Sobre Nosotros',
    box_big_p_1: 'Nuestro equipo cuenta con un grupo de profesionales financieros que tienen un gran conocimiento en el mercado latinoamericano y tienen muchas asociaciones con proveedores de servicios financieros en los Estados Unidos y en toda América del Sur',
    box_big_p_2: 'También tienen una amplia experiencia en instituciones financieras así como en comercio internacional, inversiones inmobiliarias y modelos comerciales de propiedad fraccionada de aviones.'
  }
}
